import { GetApiActionWithAuthorization } from "constantFunctions/apiActions";
import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
  Input,
  CustomInput,
  FormGroup,
} from "reactstrap";
import { DropdownList } from "react-widgets";
import { Typeahead } from 'react-bootstrap-typeahead';
import {
  manualCheckTypeOptions
} from "../../constants/ticketConstants";

function PrintStandaloneCheck(props) {
  const [payee, setpayee] = useState("");
  const timerRef = useRef(null);
  const [memo, setMemo] = useState("");
  const [checkAmount, setCheckAmount] = useState("");
  const [checkNumber, setCheckNumber] = useState("");
  const [manualCheckType, setManualCheckType] = useState("metro");
  const [displayCustomPayee, setDisplayCustomPayee] = useState(false);
  const [isVoidedAfterDay, setIsVoidedAfterDay] = useState(true);
  const [payees, setPayees] = useState([]);
  const startTimer = (_manualCheckType) => {
    if (timerRef.current) return; // Avoid multiple intervals
    timerRef.current = setInterval(() => {
      updateCheckNumber(_manualCheckType)
    }, 1000)
  };
  const stopTimer = () => {
    clearInterval(timerRef.current)
    timerRef.current = null
  };
  useEffect(() => {
    startTimer(manualCheckType)
  }, []);
  const searchPayees = (payee) => {
    GetApiActionWithAuthorization("payees/search-payee/" + payee)
    .then((res) => {
      setPayees(res.data)
    })
    .catch((e) => {});
  };

  const updateCheckNumber = (_manualCheckType = null) => {
    if (!_manualCheckType)
      _manualCheckType = manualCheckType
    //
    GetApiActionWithAuthorization("common/get-check-setting").then((res) => {
      setCheckNumber(res.data[_manualCheckType + "CheckNumberPrefix"].toString() + res.data[_manualCheckType + "CheckNextSequenceNumber"].toString());
    });
  };

  const loadPayeeSetting = (payee) => {
    GetApiActionWithAuthorization("payees/get-payee-last-data/" + payee)
    .then((res) => {
      setIsVoidedAfterDay(res.data.voidDay)
    })
    .catch((e) => {}); 
  };

  const printCheckHandler = (id, type) => {
    if (
      checkAmount !== "" &&
      parseInt(checkAmount) > 0 &&
      payee !== "" &&
      checkNumber !== "" &&
      memo !== ""
    ) {
      let body = {
        checkNumber,
        checkAmount,
        payee,
        memo,
        isVoidedAfterDay,
        manualCheckType
      };
      PostApiWithAuthorizationAction("common/print-standalone-checks", body)
        .then((res) => {
          //toast.success(res.message);
          props.refreshList();
        })
        .catch((e) => props.toggle());
    } else {
      if (parseInt(checkAmount) <= 0 && checkAmount !== "") {
        toast.error("Invalid check amount");
      } else {
        toast.error("Please fill all the fields");
      }
    }
  };

  return (
    <Modal isOpen={props.show} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>Print Standalone Check!</ModalHeader>
      <ModalBody className="py-0">
        <FormGroup className="mb-2">
          <DropdownList
            id="manualCheckType"
            data={manualCheckTypeOptions}
            containerClassName="filter-By"
            textField="label"
            valueField="value"
            value={manualCheckType}
            onChange={(e) => {
              stopTimer()
              setManualCheckType(e.value)
              startTimer(e.value)
            }}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <Label className="form-control-label">Payee:</Label>
          <Typeahead
            id="payee"
            labelKey="name"
            emptyLabel=""
            onInputChange={(e) => {
              setpayee(e)
              searchPayees(e)
              loadPayeeSetting(e)
            }}
            onChange={(e) => {
              if (e.length > 0) {
                setpayee(e[0].name)
                loadPayeeSetting(e[0].name)
              }
            }}
            options={payees}
            placeholder="Payee"
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <Label className="form-control-label">Check Amount:</Label>
          <Input
            id="checkAmount"
            type="number"
            className="ml-1"
            placeholder="Check Amount"
            autoComplete="off"
            value={checkAmount}
            onChange={(e) => setCheckAmount(e.target.value)}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <Label className="form-control-label">Memo:</Label>
          <Input
            id="memo"
            type="text"
            className="ml-1"
            placeholder="Memo"
            autoComplete="off"
            value={memo}
            onChange={(e) => setMemo(e.target.value)}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <Label className="form-control-label">Check Number:</Label>
          <Input
            id="checkNumber"
            type="text"
            className="ml-1"
            placeholder="Check Number"
            maxlength="5"
            autoComplete="off"
            value={checkNumber}
            onChange={(e) => {
              stopTimer()
              setCheckNumber(e.target.value.trim().replace(/\D/g, ""))
            }}
          />
        </FormGroup>
        <FormGroup className="mb-2">
          <Label className="form-control-label" for="b_name">
            {" "}
            Void after 30 days
          </Label>
          <CustomInput
            type="switch"
            id="isVoidedAfterDay"
            name="enabled"
            checked={isVoidedAfterDay}
            onChange={(e) => {
                setIsVoidedAfterDay(e.target.checked);
            }}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter className="pt-0">
        <Button id="print" color="primary" onClick={(e) => {
          stopTimer()
          printCheckHandler()
        }}>
          Print
        </Button>{" "}
        <Button color="secondary" onClick={(e) => {
          stopTimer()
          props.toggle()
        }}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default PrintStandaloneCheck;
